import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CreationMode } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.constants';
import { e2eLocators } from '@components/storage-accounts/add-storage-account-wizard/credential-forms/credential-forms.constants';
import { I18NextPipe } from 'angular-i18next';
import { CardGroupComponent, FormGroupComponent, InputComponent, InputLabelComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { switchMap } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { GoogleCloudCredentialForm } from '../credential-forms.model';

@Component({
  selector: 'mbs-credential-form-google-cloud',
  templateUrl: './credential-form-google-cloud.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardGroupComponent, FormGroupComponent, I18NextPipe, InputComponent, InputLabelComponent, ReactiveFormsModule]
})
export class CredentialFormGoogleCloudComponent implements OnInit {
  @Input() form: GoogleCloudCredentialForm;
  @Input() mode: CreationMode;

  protected readonly StorageType = StorageType;
  protected readonly e2eLocators = e2eLocators;

  public filesControl: FormControl = new FormControl(null);

  ngOnInit() {
    if (this.mode === CreationMode.Edit) {
      this.filesControl.patchValue([
        {
          name: '********'
        }
      ]);
    }

    this.filesControl.valueChanges
      .pipe(
        switchMap((files: FileList) => {
          return fromPromise(this.toBase64(files[0]));
        })
      )
      .subscribe((res) => {
        this.binaryKeyInBase64.patchValue(res);
      });
  }

  get serviceAccountEmail(): FormControl {
    return this.form.get('serviceAccountEmail') as FormControl;
  }

  get binaryKeyInBase64(): FormControl {
    return this.form.get('binaryKeyInBase64') as FormControl;
  }

  get projectId(): FormControl {
    return this.form.get('projectId') as FormControl;
  }

  toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve((reader.result as string).split(',')?.[1]);
      reader.onerror = reject;
    });
  }
}
